// TKT-000862: what THIS workstation prints in the statement's middle section, chosen on the
// Tax Inquiry action row instead of in Settings > Statements. The Settings value is county
// wide - changing it there changes every other counter's statements and the Taxroll Work File
// mailing - so the counter clerk had no way to switch back and forth for one taxpayer.
//
// Kept in localStorage, the same pattern as the printer config in pdf-to-printer.util.js: the
// choice belongs to the PC, has to survive a refresh and a re-login on it, and must never
// reach another desk. Nothing about it is stored server-side, and Reset on the criteria bar
// does not clear it.
const localStorageKey = 'taxStatementMiddleSection';

// The selection that sends nothing at all, leaving the backend to print exactly as it does
// today. A real value rather than '' so Vuetify's v-select has something non-falsy to match.
export const COUNTY_SETTING = 'county';

// value is what the backend receives as middleSection= (except COUNTY_SETTING, which is never
// sent); description is the second line shown in the dropdown list.
export const MIDDLE_SECTION_OPTIONS = [
  {
    value: COUNTY_SETTING,
    text: 'County Setting',
    description: 'Use Settings > Statements (no override)',
  },
  {
    value: 'message',
    text: 'Message',
    description: 'Middle message only (Normal or Delinquent text)',
  },
  {
    value: 'grid',
    text: 'If Paid By Grid',
    description: '"If paid by" date grid only',
  },
  {
    value: 'gridMessage',
    text: 'Grid + Message',
    description: 'Grid with the middle message under it',
  },
  {
    value: 'none',
    text: 'Nothing',
    description: 'Blank middle section - no message, no grid',
  },
];

const isKnownOption = (value) => MIDDLE_SECTION_OPTIONS.some((opt) => opt.value === value);

// Anything this PC does not recognise - nothing stored yet, a value left by an older build,
// storage blocked by the browser - reads as the county setting. A value we cannot vouch for
// must not be forwarded to the backend as an override.
export const getMiddleSection = () => {
  let stored;
  try {
    stored = localStorage.getItem(localStorageKey);
  } catch (e) {
    stored = null;
  }
  return isKnownOption(stored) ? stored : COUNTY_SETTING;
};

export const setMiddleSection = (value) => {
  try {
    if (isKnownOption(value) && value !== COUNTY_SETTING) {
      localStorage.setItem(localStorageKey, value);
    } else {
      // Back on the county setting: drop the key rather than store 'county', so a workstation
      // that never overrode and one that went back look identical.
      localStorage.removeItem(localStorageKey);
    }
  } catch (e) {
    // Storage blocked (private window, locked-down profile): the dropdown still works for
    // this session, it just will not be remembered.
  }
};

export const isMiddleSectionOverridden = () => getMiddleSection() !== COUNTY_SETTING;

// What to send with a statement request: '' on the county setting, so no middleSection
// reaches the backend at all.
export const middleSectionValue = () => {
  const selected = getMiddleSection();
  return selected === COUNTY_SETTING ? '' : selected;
};

// For the report URL builders. generateQueryString drops '' params, so this can be pushed
// unconditionally.
export const middleSectionParam = () => {
  const value = middleSectionValue();
  return value ? `middleSection=${value}` : '';
};

export default {
  COUNTY_SETTING,
  MIDDLE_SECTION_OPTIONS,
  getMiddleSection,
  setMiddleSection,
  isMiddleSectionOverridden,
  middleSectionValue,
  middleSectionParam,
};
